<script setup lang="ts">
import { computed } from 'vue'
import { AccessPointsUtil, type AccessPointLevel } from '@/util/access_points'

const props = defineProps<{ level: AccessPointLevel }>()

const label = computed(() => AccessPointsUtil.labelsMap[props.level])
</script>

<template>
  <!-- #1c5498 on #f8e81c has no design-system token yet; the same pair as AnchorPageLabel -->
  <span
    v-if="label"
    class="inline whitespace-nowrap rounded-xxs bg-[#1c5498] px-2 py-1 text-center align-baseline text-sm font-bold leading-none text-[#f8e81c]"
    data-testid="access-point-label"
  >{{ label }}</span>
</template>
